import { render, staticRenderFns } from "./RemoveAds.vue?vue&type=template&id=728eb8b2&scoped=true"
import script from "./RemoveAds.vue?vue&type=script&setup=true&lang=ts"
export * from "./RemoveAds.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RemoveAds.vue?vue&type=style&index=0&id=728eb8b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728eb8b2",
  null
  
)

export default component.exports